import { render, staticRenderFns } from "./StockDialog.vue?vue&type=template&id=fd958404&scoped=true"
import script from "./StockDialog.vue?vue&type=script&lang=js"
export * from "./StockDialog.vue?vue&type=script&lang=js"
import style0 from "./StockDialog.vue?vue&type=style&index=0&id=fd958404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd958404",
  null
  
)

export default component.exports